import { render } from "./adminTableModal.vue?vue&type=template&id=bd7e9bac&scoped=true"
import script from "./adminTableModal.vue?vue&type=script&lang=js"
export * from "./adminTableModal.vue?vue&type=script&lang=js"

import "./adminTableModal.vue?vue&type=style&index=0&id=bd7e9bac&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7e9bac"]])

export default __exports__